<template>
  <v-container
    id="liquidacao-cji3-historico"
    fluid
    tag="section"
  >
    <v-row>
      <v-col cols="12">
        <base-material-card
          color="primary"
          icon="mdi-cash-multiple"
          inline
          class="ml-0 px-5 py-4"
        >
          <template v-slot:after-heading>
            <div class="display-2 font-weight-light">
              Liquidação da CJI3
            </div>
          </template>

          <v-btn
            id="btn-nova-liquidacao-cji3"
            color="success"
            dark
            elevation="1"
            class="mt-5"
            style="float:left"
            relative
            text
            medium
            @click="$router.push(`edit`)"
          >
            <v-icon
              left
              size="30px"
            >
              mdi-plus-circle
            </v-icon>
            Nova Liquidação da CJI3
          </v-btn>

          <v-text-field
            id="liquidacao-cji3-historico-search"
            v-model="search"
            append-icon="mdi-magnify"
            class="break-search bs-liquidacao-cji3 ml-auto mt-4"
            label="Procurar"
            hide-details
            single-line
            style="max-width: 250px;"
          />

          <general-progress-bars
            class="mt-11"
            :items="downloadProgressData"
            prefix-text="Baixando Liquidação da CJI3"
          />

          <v-divider class="mt-10" />

          <v-data-table
            class="liquidacao-cji3-table"
            :headers="headers"
            :items="liquidacoes"
            :search.sync="search"
            :header-props="{
              sortByText: 'Ordenar Por'
            }"
            :footer-props="{
              itemsPerPageText: 'Itens por Página'
            }"
            no-data-text="Nenhuma Liquidação da CJI3 disponível"
            no-results-text="Nenhum registro correspondente encontrado"
            mobile-breakpoint="800"
          >
            <template v-slot:[`item.id`]="{ item }">
              {{ item.id }}
            </template>
            <template v-slot:[`item.nome`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <div
                    class="text-truncate-column"
                    v-bind="attrs"
                    v-on="on"
                  >
                    {{ item.nome }}
                  </div>
                </template>
                <span>{{ item.nome }}</span>
              </v-tooltip>
            </template>
            <template v-slot:[`item.usuario`]="{ item }">
              {{ item.usuario }}
            </template>
            <template v-slot:[`item.executed`]="{ item }">
              {{ item.executed }}
            </template>
            <template v-slot:[`item.status`]="{ item }">
              <general-status :status="item.status" />
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-btn
                id="action-download-liquidacao-cji3"
                :class="item.status != 'SUCESSO' ? 'cursor-block' : ''"
                :disabled="item.status != 'SUCESSO'"
                color="gray"
                min-width="0"
                class="px-1"
                fab
                icon
                x-small
                :loading="
                  downloadProgressData[item.id] !== undefined ? true : false
                "
                @click="downloadItem(item)"
              >
                <v-icon small>
                  mdi-download
                </v-icon>
              </v-btn>
              <v-menu 
                v-if="item.status == 'SUCESSO' || canRunItem(item) || canDeleteItem(item)"
                offset-y
                right
              >
                <template 
                  v-slot:activator="{ on, attrs }"
                >
                  <v-btn
                    id="action-more-liquidacao-cji3"
                    color="white"
                    class="ml-1"
                    height="22px"
                    width="22px"
                    fab
                    x-small
                    elevation="1"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon small>
                      mdi-dots-vertical
                    </v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-if="canRunItem(item)"
                    @click="executarLiquidacaoCji3(item.id)"
                  >
                    <v-list-item-icon class="mx-0 my-0 py-4">
                      <v-icon small>
                        mdi-play
                      </v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>
                      Executar
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="canDeleteItem(item)"
                    @click="openDeleteDialog(item)"
                  >
                    <v-list-item-icon class="mx-0 my-0 py-4">
                      <v-icon small>
                        mdi-trash-can-outline
                      </v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>
                      Deletar
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    @click="openDialogDetalhes(item)"
                  >
                    <v-list-item-icon class="mx-0 my-0 py-4">
                      <v-icon small>
                        mdi-file-find-outline
                      </v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>
                      Detalhes
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
            <template v-slot:[`footer`]>
              <v-switch
                v-if="$store.getters.userIsAdmin"
                class="pa-0 pl-2 swithInterna"
                style="position: absolute" 
                color="primary"
                label="Exibir Expirados"
                dense
                @change="processamentosExpirados = $event, getAllLiquidacoes()"
              />
            </template>
          </v-data-table>
        </base-material-card>

        <dialog-delete
          :show-dialog="dialogDelete"
          @changeValue="dialogDelete = $event"
          @deleteTriggered="deletarLiquidacaoCji3(dialogDeleteData.id)"
        >
          <template slot="title">
            Deletar Liquidação da CJI3 #{{ dialogDeleteData.id }}
          </template>
          <template slot="body">
            Tem certeza que deseja deletar <strong>{{ dialogDeleteData.nome }}</strong>? 
          </template>
        </dialog-delete>
      </v-col>
    </v-row>

    <general-dialog-detalhes
      ref="dialogDetalhes"
      title="Detalhes"
      :show-dialog="dialogDetalhes"
      @changeValue="dialogDetalhes = $event"
    >
      <template slot="body">
        <v-data-table
          :headers="dialogDetalhesHeader"
          :items="dialogDetalhesData"
          hide-default-footer
          class="elevation-1 style-table-dialog-detalhes"
          disable-pagination
          mobile-breakpoint="10"
        />
      </template>
    </general-dialog-detalhes>
  </v-container>
</template>

<script>
import LiquidacaoCji3Service from '@/services/LiquidacaoCji3Service';
import powerupsActionsMixins from '@/mixins/powerupsActionsMixins.js';
import DateFormatterMixins from '@/mixins/dateFormatterMixins.js';
import pusherMixins from '@/mixins/pusherMixins';
import tourMixins from '@/mixins/tourMixins';
import dayjs from 'dayjs';

export default {

  components: {
    DialogDelete: () => import('@/components/general/DialogDelete'),
    GeneralProgressBars: () => import('@/components/general/GeneralProgressBars.vue'),
    GeneralStatus: () => import('@/components/general/GeneralStatus.vue'),
    GeneralDialogDetalhes: () => import('@/components/general/GeneralDialogDetalhes')
  },
  
  mixins: [powerupsActionsMixins, DateFormatterMixins, pusherMixins, tourMixins],

  data() {
    return {
      processamentosExpirados: false,
      powerupService: LiquidacaoCji3Service,
      powerupEntityName: 'Liquidacao_CJI3',
      arrTour: [
        {
          element: '#btn-nova-liquidacao-cji3',
          intro: 'Clicando neste botão você poderá criar novas Liquidações da CJI3.',
          scrollTo: 'tooltip',
          position: 'right'
        },
        {
          element: '#liquidacao-cji3-historico-search',
          intro: 'Neste campo você poderá pesquisar por Liquidações da CJI3 já existentes.',
          scrollTo: 'tooltip',
          position: 'bottom'
        },
        {
          element: '#action-download-liquidacao-cji3',
          intro: 'Clicando neste ícone você poderá fazer o download em .XLSX do resultado de sua Liquidação da CJI3.',
          scrollTo: 'tooltip',
          position: 'left'
        },
        {
          element: '#action-more-liquidacao-cji3',
          intro: 'Aqui você acessa outras opções para sua Liquidação da CJI3, como executá-la novamente ou deletá-la.',
          scrollTo: 'tooltip',
          position: 'left'
        }
      ],
      headers: [
        {
          text: '#',
          value: 'id'
        },
        {
          text: 'Nome',
          value: 'nome'
        },
        {
          text: 'Usuário',
          value: 'usuario'
        },
        {
          text: 'Executado',
          value: 'executed'
        },
        {
          text: 'Status',
          value: 'status'
        },
        {
          sortable: false,
          text: 'Ações',
          value: 'actions',
          class: 'pl-4'
        }
      ],
      liquidacoes: [],
      search: '',
      dialogDelete: false,
      dialogDeleteData: { id: undefined, nome: undefined },
      downloadProgressData: {},
      dialogDetalhes: false,
      dialogDetalhesData: [],
      dialogDetalhesHeader: [
        { text: 'Resumo', value: 'parametro', sortable: false },
        { text: 'Valor', value: 'valor', sortable: false }
      ]
    };
  },

  computed: {
    user() {
      return this.$store.getters.getUser;
    }
  },

  mounted() {
    this.getAllLiquidacoes();
    this.subscribe();
  },

  methods: {
    subscribe() {
      this.pusherChannel.bind('refreshLiquidacaoCji3', () => {
        this.getAllLiquidacoes();
      });
    },

    getAllLiquidacoes() {

      LiquidacaoCji3Service.getLiquidacoes(this.processamentosExpirados)
        .then(response => {
          this.liquidacoes = [];

          response.data.liquidacoes.forEach(liq => {
            this.liquidacoes.push({
              id: liq.id,
              nome: liq.nome,
              usuario: liq.usuario.nome,
              usuario_id: liq.usuario.id,
              executed: liq.executado_em
                ? dayjs(liq.executado_em).format('DD/MM/YYYY HH:mm')
                : '-',
              status: liq.status,
              codigosObra: liq.codigos_obra ? liq.codigos_obra.join(', ') : '-'
            });
          });
        })
        .catch(err => {
          console.log('Erro: ', err);
          this.$toast.error('Erro ao carregar Liquidações da CJI3.', '', { position: 'topRight' });
        })
        .finally(()=>{
          this.iniciarTourPagina();
        });
    },

    iniciarTourPagina() {
      if (this.tourFuncCalled) return;
      let arrTourFormatted = this.liquidacoes.length ? this.arrTour : this.arrTour.splice(0, 2);
      this.iniciarTour(arrTourFormatted);
    },

    openDeleteDialog(liquidacao) {
      
      this.dialogDeleteData = {
        id: liquidacao.id,
        nome: liquidacao.nome
      };

      this.dialogDelete = true;
    },

    deletarLiquidacaoCji3(id) {
      
      this.dialogDelete = false;
      
      LiquidacaoCji3Service.excluirLiquidacaoCji3(id)
        .then(() => {
          this.getAllLiquidacoes();
          this.$toast.success('Liquidação da CJI3 excluída com sucesso.', '', { position: 'topRight' });
        })
        .catch(err => {
          this.$toast.error('Erro ao excluir Liquidação da CJI3.', '', { position: 'topRight' });
          console.log('Erro: ', err);
        });
    },

    executarLiquidacaoCji3(id) {
      
      LiquidacaoCji3Service.executarLiquidacaoCji3(id)
        .then(() => {
          this.$toast.info('Sua planilha será gerada em instantes. Por favor, aguarde.', '', { position: 'topRight', timeout: 2000 });
          this.getAllLiquidacoes();
        })
        .catch(err => {
          this.$toast.error('Erro ao executar Liquidação da CJI3.', '', { position: 'topRight' });
          console.log('Erro: ', err);
        });
    },

    openDialogDetalhes(liquidacao) {
      
      this.dialogDetalhesData = [
        {
          parametro: 'NOME:',
          valor: liquidacao.nome
        },
        {
          parametro: 'CÓDIGOS DE OBRA:',
          valor: liquidacao.codigosObra !== '-' ? liquidacao.codigosObra : '-'
        }
      ];

      this.dialogDetalhes = true;
    }
  }
};
</script>

<style>

@media screen and (min-width: 800px) {
  .liquidacao-cji3-table table tr td:nth-child(2) {
    max-width: 200px;
  }

  .liquidacao-cji3-table table tr td:nth-child(7),
  .liquidacao-cji3-table table tr td:nth-child(8) {
    white-space: nowrap !important;
  }
}

@media screen and (max-width: 480px) {
  .bs-liquidacao-cji3 {
    width: 235.86px !important;
  }
}

.swithInterna label {
  font-size: 13px !important;
  margin-left: 0px !important;
}

</style>


